import { Helmet } from 'react-helmet-async';
import { siteConfig } from '@/data/site';

type SeoProps = {
  title: string;
  description: string;
  path?: string;
};

export const Seo = ({ title, description, path = '/' }: SeoProps) => {
  const canonical = `${siteConfig.siteUrl}${path}`;

  return (
    <Helmet>
      <title>{`${title} | ${siteConfig.name}`}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
